import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa'

const testimonialsData = []

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonialsData.length)
  }

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonialsData.length) % testimonialsData.length)
  }

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Real experiences from people who found their perfect home with us
          </p>
        </motion.div>

        {testimonialsData.length === 0 ? (
          <div className="max-w-4xl mx-auto text-center py-12">
            <p className="text-gray-500 text-lg">No testimonials yet. Check back soon!</p>
          </div>
        ) : (
          <div className="max-w-4xl mx-auto relative">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
              className="bg-gradient-to-tr from-primary-50 via-white to-accent-50 rounded-3xl p-8 md:p-14 shadow-soft border border-primary-100"
            >
              <FaQuoteLeft className="text-5xl text-primary-200 mb-6" />
              
              <div className="flex items-center gap-2 mb-6">
                {[...Array(5)].map((_, i) => (
                  <FaStar
                    key={i}
                    className={`${
                      i < testimonialsData[currentIndex].rating
                        ? 'text-accent-500'
                        : 'text-gray-200'
                    } text-xl`}
                  />
                ))}
              </div>

              <p className="text-secondary-700 text-lg md:text-2xl mb-10 leading-relaxed font-heading font-medium">
                "{testimonialsData[currentIndex].comment}"
              </p>

              <div className="flex items-center gap-5 border-t border-primary-100 pt-6">
                <img
                  src={testimonialsData[currentIndex].image}
                  alt={testimonialsData[currentIndex].name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-md"
                />
                <div>
                  <h4 className="font-heading font-bold text-lg text-secondary-900">
                    {testimonialsData[currentIndex].name}
                  </h4>
                  <p className="text-secondary-500 font-medium">
                    {testimonialsData[currentIndex].location}
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Navigation Buttons */}
            <button
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 -ml-2 sm:-ml-4 md:-ml-6 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition z-10"
            >
              <FaChevronLeft className="text-primary-600" />
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 -mr-2 sm:-mr-4 md:-mr-6 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition z-10"
            >
              <FaChevronRight className="text-primary-600" />
            </button>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-8">
              {testimonialsData.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    idx === currentIndex
                      ? 'w-8 bg-primary-600'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default Testimonials